<script>
export default {
  name: 'CpRepresentativesSection',
  components: {
    CpBox: require('../box').default,
    CpButton: require('../button').default,
    VueSimpleSpinner: require('../vue-simple-spinner').default,
    InfiniteLoading: require('vue-infinite-loading').default,
    CpSocialFeedLobbyPost: require('./posts/lobby-post').default,
    CpSearcher: require('../lobbying/Searcher').default,
    CpLeadership: require('../lobbying/Leadership').default,
    CpDivider: require('../components/Divider').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginLeft: require('../directives/margins').marginLeft,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
  },
  props: {
    currentUser: { type: Object },
    loadLobbies: { type: Function },
    lobbies: { type: Array },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<template>
  <CpBox>
    <CpSearcher />
    <CpLeadership v-margin-top="1" />
    <CpDivider title="Discover who others are contacting" />
    <transition-group name="feed-fade">
      <CpSocialFeedLobbyPost v-for="lobby in lobbies" :key="lobby.id" :lobby="lobby" :for-share="false" :explore="true" :iconState="true" :user="currentUser" />
    </transition-group>
    <transition name="feed-fade">
      <InfiniteLoading @infinite="loadLobbies" v-margin="1">
        <div slot="spinner">
          <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading more...</div>
        </div>
        <div slot="no-more">
          <div class="heading-4">That's all!</div>
        </div>
        <div slot="no-results">
          <div class="heading-4">That's all!</div>
        </div>
      </InfiniteLoading>
    </transition>
  </CpBox>
</template>

<style scoped>
@media screen and (max-width: 768px) {
  .search-section {
    width: 100%;
  }
}
</style>
